module.exports = __webpack_public_path__ + "static/media/iStock-1205439297.65ea0ade.jpg";